import type { Provider } from '@angular/core';

import { provideTellentAssistantRenderPresenter } from '@core/tellent-assistant-contracts';

import { PresentDispatcherComponent } from '../present-dispatcher/present-dispatcher.component';

export const providePresentClientTool: Provider = provideTellentAssistantRenderPresenter({
  id: 'present',
  component: PresentDispatcherComponent,
});
